export default class SkipFirstRow {
    #element
    #firstRowElement

    constructor(element) {
        this.#element = element
        this.#firstRowElement = document.querySelector(element.dataset.gpTarget)

        this.#bindEvents()

        this.#handleClick()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new SkipFirstRow(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', () => {
            this.#handleClick()
        })
    }

    #handleClick() {
        let skipFirstRow = this.#element.checked

        this.#firstRowElement.classList.toggle('bg-white', !skipFirstRow)
        this.#firstRowElement.classList.toggle('bg-gray-200', skipFirstRow)
    }
}
